import { useEffect, useState } from "react";

// Edgar's settings, shared by the chat panel and the Research setup card (synced across components).
const KEY = "snaplist.edgarVoice";
const DEFAULTS = { enabled: true, on: false, loop: false, wakeOn: false, rate: 1, setup: false };
const read = () => { try { return { ...DEFAULTS, ...JSON.parse(localStorage.getItem(KEY)) }; } catch { return { ...DEFAULTS }; } };
let current = read();
const subs = new Set();

export function setEdgarPrefs(next) {
  current = { ...current, ...next };
  localStorage.setItem(KEY, JSON.stringify(current));
  subs.forEach((f) => f(current));
}

export function useEdgarPrefs() {
  const [p, setP] = useState(current);
  useEffect(() => { subs.add(setP); setP(current); return () => subs.delete(setP); }, []);
  return [p, setEdgarPrefs];
}
